import { createAction } from '@reduxjs/toolkit';

export const project = {
    details: {
        set: createAction('project/details/set'),
        reset: createAction('project/details/reset'),
    },
};
